export default {
  JOURNEYS_LOAD: 'JOURNEYS_LOAD',
  JOURNEYS_FETCHED: 'JOURNEYS_FETCHED',
  JOURNEYS_BUTTON_LOADING: 'JOURNEYS_BUTTON_LOADING',
  JOURNEYS_DETAIL_LOAD: 'JOURNEYS_DETAIL_LOAD',
  JOURNEYS_DETAIL_FETCHED: 'JOURNEYS_DETAIL_FETCHED',
  ACTIONS_LOAD: 'JOURNEYS_ACTIONS_LOAD',
  ACTIONS_FETCHED: 'JOUNEYS_ACTIONS_FETCHED',
  REPORT_LOAD: 'JOURNEYS_REPORT_LOAD',
  REPORT_FETCHED: 'JOURNEYS_REPORT_FETCHED',
  RANKING_LOAD: 'JOURNEYS_RANKING_LOAD',
  RANKING_FETCHED: 'JOURNEYS_RANKING_FETCHED',
  RANKING_ERROR: 'JOURNEYS_RANKING_ERROR',
};
